var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.view
    ? _c(
        "div",
        { staticClass: "Header", class: [_vm.topClass], style: _vm.topStyle },
        [
          _vm.view !== "QR" && _vm.view !== "Turn" && _vm.view != "Home"
            ? _c(
                "button",
                {
                  staticClass:
                    "button-without-styles d-inline-block align-middle",
                  on: { click: _vm.back }
                },
                [
                  _c("p", { staticClass: "goback my-0" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "13",
                          height: "21",
                          viewbox: "0 0 13 21",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M9.48675 20.5287L0.469899 11.6232C0.168932 11.3247 0 10.9209 0 10.5C0 10.0791 0.168932 9.67534 0.469899 9.37685L9.48675 0.471272C9.71277 0.246595 10.0015 0.0933667 10.3162 0.0311238C10.6309 -0.0311191 10.9573 0.000443073 11.2537 0.121786C11.5502 0.24313 11.8032 0.448756 11.9807 0.71245C12.1581 0.976144 12.2518 1.28596 12.25 1.60239V19.3976C12.2518 19.714 12.1581 20.0239 11.9807 20.2876C11.8032 20.5512 11.5502 20.7569 11.2537 20.8782C10.9573 20.9996 10.6309 21.0311 10.3162 20.9689C10.0015 20.9066 9.71277 20.7534 9.48675 20.5287Z",
                            fill: "#6BBBC5"
                          }
                        })
                      ]
                    ),
                    _c(
                      "span",
                      { staticClass: "ml-2 d-inline-block align-middle" },
                      [_vm._v("Atrás")]
                    )
                  ])
                ]
              )
            : _c("span"),
          _vm.view !== "QR"
            ? _c("div", { staticClass: "imageContainerHeader" }, [
                _c("img", {
                  directives: [{ name: "openlog", rawName: "v-openlog" }],
                  class: [_vm.logoClass],
                  style: _vm.logoStyle,
                  attrs: { src: _vm.Logo }
                })
              ])
            : _c("div", { staticClass: "imageContainerHeader" }, [
                _c("img", {
                  directives: [{ name: "openlog", rawName: "v-openlog" }],
                  staticClass: "p-0",
                  class: [_vm.logoClass],
                  style: _vm.logoStyle,
                  attrs: { src: _vm.Logo }
                })
              ]),
          _c("span")
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }